module.exports = __webpack_public_path__ + "img/basket.4fa9cd13.svg";